export const LastLoginUsernameKey = 'LastLoginUsername';
export const UnauthorizedErrorKey = 'UnauthorizedErrorMessage';
